import { ApiImageClient } from "@/api";

async function apiUserGetAccountsProject({ id }: { id: string }) {
  try {
    const result = await ApiImageClient.get(`/projects/${id}?populate=*`).then(
      ({ data }) => data,
    );
    return result;
  } catch (e) {
    console.error("apiUserGetAccountsProject_Error", e);
    return e;
  }
}

async function apiUserGetAccountsProjects({
  company,
  page = 1,
  pageSize = 10,
  sort = null,
  name = "",
  date = "",
  partner = "",
}: {
  company: string;
  page?: number;
  pageSize?: number;
  sort?: string | null;
  name?: string;
  date?: string;
  partner?: string;
}) {
  try {
    let url = `/projects?populate=*&filters[company][documentId][$eq]=${company}&pagination[page]=${page}&pagination[pageSize]=${pageSize}`;

    if (sort) {
      url += `&sort=${sort}`;
    }

    if (name) {
      url += `&filters[name][$containsi]=${encodeURIComponent(name)}`;
    }

    if (date) {
      url += `&filters[date][$containsi]=${encodeURIComponent(date)}`;
    }

    if (partner) {
      url += `&filters[partner][name][$containsi]=${encodeURIComponent(partner)}`;
    }

    const result = await ApiImageClient.get(url).then(({ data }) => data);
    return result;
  } catch (e) {
    console.error("apiUserGetAccountsProjects_Error", e);
    return e;
  }
}

async function apiUserPostAccountsProject({ data }: { data: any }) {
  try {
    const result = await ApiImageClient.post("/projects", { data }).then(
      ({ data }) => data,
    );
    return result;
  } catch (e) {
    console.error("apiUserPostAccountsProject_Error", e);
    return e;
  }
}

async function apiUserPutAccountsProjects({
  id,
  data,
}: {
  id: string;
  data: any;
}) {
  try {
    const result = await ApiImageClient.put(`/projects/${id}`, { data }).then(
      ({ data }) => data,
    );
    return result;
  } catch (e) {
    console.error("apiUserPutAccountsProjects_Error", e);
    return e;
  }
}

async function apiUserDeleteAccountsProject({ id }: { id: string }) {
  try {
    const result = await ApiImageClient.delete(
      `/projects/${id}?populate=*`,
    ).then(({ data }) => data);
    return result;
  } catch (e) {
    console.error("apiUserDeleteAccountsProject_Error", e);
    return e;
  }
}

export {
  apiUserPostAccountsProject,
  apiUserPutAccountsProjects,
  apiUserGetAccountsProjects,
  apiUserGetAccountsProject,
  apiUserDeleteAccountsProject,
};
